import {Component} from '@angular/core';
import {LocalStorageService, UserService} from '../../_services';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {environment} from '../../../environments/environment';
import {CommonService} from '../../_services/common.service';
import {ModalController} from '@ionic/angular';

@Component({
  selector: 'app-why-log-out',
  templateUrl: './log-out.component.html',
  styleUrls: ['./log-out.scss']
})

export class LogOutComponent {
  currentUser;

  constructor(public authService: UserService,
              private router: Router,
              private modal: ModalController,
              private commonService: CommonService,
              private localStorageService: LocalStorageService,
              private location: Location) {
    this.currentUser = this.localStorageService.get(environment.currentUser);
  }

  logOut() {
    this.modal.dismiss();
    this.authService.logout();
    this.router.navigate(['./map']);
  }

  stayIn() {
    this.modal.dismiss();
  }
}
